import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const miniCartDueToday = Loadable(() => import('../FuncContainers/miniCartDueToday'));
export default MapTo('vcg/components/soe-home/react/common/miniCartFunctionalDueToday')(miniCartDueToday);
